import React from 'react';
import { useIcons } from '../../utils/hooks';

import { ValidationContext } from './ValidationProvider';

function ValidationWrapper({
	children,
	value,
	name,
	colors,
	required,
	checkbbdd,
	event,
	confirmValue,

	/* Array value options */
	isValueArray,
	minSelections,
	uniqueValues,

	/* OPTIONAL PROPS */
	isPhoneInput,
	isVote,
	styleDIV,
	showValidationCustom = true,
	showIcons,
	keepEmptySpace = true,
	errorOnTop,
	classNameDIV = 'flex pb-2',
	classNameDIVIMG = 'flex p-1 items-end',
	classNameIMG,
	hiddeDefaultError,
	confirmError,
	classNameERROR = 'text-xs md:text-sm cursor-default',
	classNameERRORBOTTOM = 'text-xs md:text-sm w-full cursor-default',
	classNameVOTE = 'text-xs md:text-sm cursor-default',
	classNamePHONE = 'text-xs md:text-sm absolute w-full block top-10 cursor-default',
}) {
	/* First error of the errors array */
	const [error, setError] = React.useState();

	/* Icon hook */
	const { CrossCircle: ErrorIcon, CheckCircle: SuccessIcon } = useIcons(colors);

	/* Validation context */
	const {
		showValidation, validateInput, validateArrayInput, revalidate, revalidateInputs
	} = React.useContext(ValidationContext);

	/* Validate call function */
	function validate() {
		/* If the input has an array of values like checkbox */
		if (isValueArray) {
			if (confirmValue) {
				return validateArrayInput({
					name,
					value,
					required,
					checkbbdd,
					customChecks: [val => val !== confirmValue && confirmError],
					minSelections,
					uniqueValues
				});
			}
			return validateArrayInput({
				name, value, required, checkbbdd, minSelections, uniqueValues
			});
		}
		/* If the input a single value */
		if (confirmValue !== undefined) {
			return validateInput({
				name,
				value,
				required,
				checkbbdd,
				customChecks: [val => val !== confirmValue && confirmError],
				minSelections
			});
		}
		return validateInput({
			name, value, required, checkbbdd, minSelections
		});
	}

	/* Wrap the validate function in an useCallback so it get's memoized */
	const updateError = React.useCallback(() => validate(), [value, confirmValue]);

	/* Wrap the useCallback in an useEffect to avoid continous rerender */
	React.useEffect(() => {
		setError(updateError()[0]);
	}, [updateError]);

	React.useEffect(() => {
		setError(validate()[0]);
	}, [revalidate]);
	React.useEffect(() => {
		revalidateInputs();
	}, [value]);

	/* Check which color to paint the border with */
	const validateColor = React.useCallback(() => (showValidation && error && colors?.error)
		|| (showValidation && colors?.primary)
		|| (event ? colors?.primary : colors?.deactivated),
	[showValidation, error, colors, event]);

	/* Default values for the styles */
	const defaultStyleDIV = {
		color: colors?.text,
		backgroundColor: colors?.background,
		borderBottom: `2px solid ${validateColor()}`,
	};
	const defaultStyleError = {
		color: colors?.error,
		/* To keep the display consistent if showError we either display the error or we leave a rendered empty space */
		display: (showValidation && !error && !keepEmptySpace && 'none') || (showValidation && 'flex') || 'none',
		visibility: (hiddeDefaultError && 'hidden') || (error && 'visible') || 'hidden',
	};
	const defaultStylePHONE = {
		color: colors?.error,
		/* To keep the display consistent if showError we either display the error or we leave a rendered empty space */
		display: (showValidation && !error && !keepEmptySpace && 'none') || (showValidation && 'flex') || 'none',
		visibility: (error && 'visible') || 'hidden',
	};
	const defaultStyleVOTE = {
		color: colors?.error,
		/* To keep the display consistent if showError we either display the error or we leave a rendered empty space */
		display: (showValidation && error && 'flex') || 'none',
	};
	const defaultStyleErrorIcon = {
		fill: colors?.error,
	};
	const defaultStyleSuccessIcon = {
		fill: colors?.success,
	};

	/* This way you can modify or add fields without affecting the others */
	const overrideStyleDIV = { ...defaultStyleDIV, ...styleDIV };

	return <div
		className='space-y-3'
	>
		{/* TOP ERROR TEXT */}
		{errorOnTop && !isVote && showValidationCustom
			&& <span
				className={classNameERROR}
				style={defaultStyleError}
			>
				{/* If hideError, error has to be small to keep sizes */}
				{(hiddeDefaultError ? '.' : error) || 'Success'}
			</span>}

		{/* SPECIAL TOP ERROR FOR RADIO AND CHECK VOTEs */}
		{errorOnTop && isVote && showValidationCustom
			&& <span
				className={classNameVOTE}
				style={defaultStyleVOTE}
			>
				{error || 'Success'}
			</span>}

		{/* DIV THAT CONTAINS INPUT CHILDREN AND ICONS */}
		<div
			className={classNameDIV}
			style={overrideStyleDIV}
		>
			{/* CHILDREN */}
			{children}

			{/* ERROR AND SUCCESS ICONS */}
			{showIcons && showValidation && showValidationCustom
				&& <div className={classNameDIVIMG}>
					{error ?
						ErrorIcon && ErrorIcon({ className: classNameIMG, style: defaultStyleErrorIcon })
						: SuccessIcon && SuccessIcon({ className: classNameIMG, style: defaultStyleSuccessIcon })
					}
				</div>}
		</div>

		{/* BOTTOM ERROR TEXT */}
		{!errorOnTop && showValidationCustom && <span
			className={classNameERRORBOTTOM}
			style={defaultStyleError}
		>
			{/* If hideError, error has to be small to keep sizes */}
			{(hiddeDefaultError ? '.' : error) || 'Success'}
		</span>}

		{/* SPECIAL BOTTOM ERROR FOR PHONE INPUTS */}
		{!errorOnTop && showValidationCustom && isPhoneInput
			&& <span
				className={classNamePHONE}
				style={defaultStylePHONE}
			>
				{error || 'Success'}
			</span>}
	</div>;
}

export default ValidationWrapper;
